<template>
	<div v-if="!loading">
		<iframe :src="userUrl + '/user/sync'" v-if="!frameElement" frameborder="0" width="0" height="0" id="userFrame" name="userFrame"></iframe>
		<iframe :src="ctcUrl" v-if="!frameElement" frameborder="0" width="0" height="0" id="ctcFrame" name="ctcFrame"></iframe>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				loading: true,
				ctcUrl: undefined,
				userUrl: undefined,
				frameElement: false
			}
		},
		methods: {
			SetupListener() {
				var self = this;
				const ctcUrl = this.ctcUrl;
				const userUrl = this.userUrl;
				window.onmessage = function (e) {
					if (e.origin !== ctcUrl && e.origin !== userUrl) {
						console.error("Invalid Origin.");
						return;
					}

					try {
						//console.log("data", e.data)
						var payload = JSON.parse(e.data);

						if (payload.ACTION === "LOGIN") {
							if (payload.CTC_USER)
								localStorage.setItem("CTC_USER", payload.CTC_USER);
							if (payload.CTC_AUTH_TOKEN)
								localStorage.setItem("CTC_AUTH_TOKEN", payload.CTC_AUTH_TOKEN);
							if (payload.CTC_REFRESH_TOKEN)
								localStorage.setItem("CTC_REFRESH_TOKEN", payload.CTC_REFRESH_TOKEN);
						}
						else if (payload.ACTION === "LOGOUT") {
							self.$store.dispatch("silent_logout");
						}
					}
					catch (err) {
						console.error(err)
					}
				}
			}
		},
		mounted() {
			this.frameElement = window.frameElement;

			this.ctcUrl = process.env.VUE_APP_CTCUrl;
			this.userUrl = process.env.VUE_APP_UserUrl;
			this.loading = false;

			this.$nextTick(() => {
				this.SetupListener();
			});
		}
	}
</script>
